import { Component, ElementRef, Input } from '@angular/core'

const FOCUSABLE = 'input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled])'

/**
 * "N required fields left to fill" with a red chip per missing field. Tapping a chip scrolls to the element on the
 * same page whose data-target names that chip ("A|B" for several) and focuses the first control in it.
 */
@Component({
  selector: 'rt-missing',
  template: `
    <section class="rt-missing" [class.is-complete]="!missing.length" aria-live="polite">
      <header class="rt-missing__head">
        <b>{{ headline }}</b>
        <span class="rt-missing__hint">Fields marked <i class="rt-missing__star">*</i> must be completed before you can finish</span>
      </header>
      <ul *ngIf="missing.length" class="rt-missing__list">
        <li *ngFor="let m of missing" class="rt-missing__chip">
          <button type="button" class="rt-missing__jump" (click)="jumpTo(m)">{{ m }}</button>
        </li>
      </ul>
    </section>`,
})
export class RtMissingComponent {
  @Input() missing: readonly string[] = []

  constructor(private host: ElementRef<HTMLElement>) {}

  get headline(): string {
    const n = this.missing.length
    if (n === 0) return 'All required fields complete'
    return n === 1 ? '1 required field left to fill' : `${n} required fields left to fill`
  }

  jumpTo(chip: string) {
    const root = this.host.nativeElement.closest('.ion-page') ?? document
    const targets = Array.from(root.querySelectorAll<HTMLElement>('[data-target]'))
    const find = (label: string) => targets.find(e => (e.dataset['target'] ?? '').split('|').includes(label))
    // "Model — invalid characters" names the control "Model"; the DSR's "Start / end time — Bobby" is a target as is.
    const el = find(chip) ?? find(chip.split(' — ')[0])
    if (!el) return
    el.scrollIntoView({ behavior: 'smooth', block: 'center' })
    const control = el.matches(FOCUSABLE) ? el : el.querySelector<HTMLElement>(FOCUSABLE)
    control?.focus({ preventScroll: true })
  }
}
